import { useQuery } from "@tanstack/react-query";
import Table from "../../ChildComponents/Table";
import { MdEditDocument } from "react-icons/md";

import { useGetlocation } from "../../store/api/locationApi";

function RoleList({ onEdit }) {
  const getLocation = useGetlocation();
  const {
    data: locationData,
    isLoading: isLocationLoading,
    error: locationError,
  } = useQuery({ queryKey: "location", queryFn: getLocation });

  const data = locationData?.upazila

    ?.map((role, index) => ({
      index: index + 1,
      name: role?.name,
      // accessPoint: role?.accessPoint?.join(", "),
      // actionButton: (
      //   <>
      //     <button
      //       onClick={() => onEdit(role)}
      //       className="btn text-success mx-2"
      //     >
      //       <MdEditDocument />
      //     </button>
      //   </>
      // ),
    }))
    .reverse();

  const columns = [
    {
      header: "SL#",
      accessor: "index",
    },
    {
      header: "Upazila",
      accessor: "name",
    },
  ];
  return (
    <div>
      <Table columns={columns} data={data} isLoading={isLocationLoading} />
    </div>
  );
}

export default RoleList;
